import { render, staticRenderFns } from "./PurchasingReceived.vue?vue&type=template&id=ad0a88fe&"
import script from "./PurchasingReceived.vue?vue&type=script&lang=js&"
export * from "./PurchasingReceived.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingReceived.vue?vue&type=style&index=0&id=ad0a88fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports